import { render, staticRenderFns } from "./AddSalary.vue?vue&type=template&id=911edfa8&"
import script from "./AddSalary.vue?vue&type=script&lang=js&"
export * from "./AddSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports